"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shade = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _ShadeElement = require("./ShadeElement");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.grey.A400,
  display: 'flex',
  alignItems: 'center'
}));
const Shade = exports.Shade = /*#__PURE__*/(0, _react.memo)(({
  colorHexCode,
  colorImageSrc,
  colorName
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ShadeElement.ShadeElement, {
    colorHexCode: colorHexCode,
    colorImageSrc: colorImageSrc
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    variant: "caption",
    children: colorName
  })]
}));
//# sourceMappingURL=Shade.js.map